import React from 'react';
import { useSelector } from 'react-redux';
import { seoStateSelector } from '@stencil/flights-seo-reducers/src/SRP/redux/selectors';
import SeoSrpCarousel from '../srp-card/seo-srp-carousel';
import ListForLinks from '@stencil/commonstories/src/components/Seo/list-for-links/list-for-links';
import SrcDestDistance from '@stencil/commonstories/src/components/Seo/list-for-links/distance-src-dest';
import Offer from '@stencil/commonstories/src/components/Seo/offers/offer';
import AirportContact from '@stencil/commonstories/src/components/Seo/airport-contact/airport-contact';
import AirlineContactInfo from '@stencil/commonstories/src/components/Seo/airline-contact-info/airline-contact-info';
import HotelsAttractionsInformation from '@stencil/commonstories/src/components/Seo/hotels-attractions-information/hotels-attractions-information';
import getListWithNewTitle from '@stencil/flights-utils/src/get-list-with-new-title';
import { FLIGHTS_TEXT, FLIGHT_SCHEDULE_TEXT, TO } from '@stencil/flights-constants/src/text';

const SrpSeoLeft = () => {
  const seoState = useSelector(seoStateSelector);

  const {
    src,
    dest,
    source,
    destination,
    airlineInfo,
    hotels,
    htl_city_links,
    popular_hotels,
    attractions,
    offers,
    offersFromDb,
    queryType,
    language,
    udaanSectors,
    newSectors,
    popularSectors,
    topSectors,
    topSectorsFromSource,
    topSectorsToDestination,
    topAirlines,
    popularLongHaulFlights,
    intlFlightsFromSource,
    intlFlightsToDestination,
    domAirlines,
    topIntlRoutes,
    topIntlCities,
    topIntlRouteAirlines,
    intlAirlines,
    sourceAirport,
    destinationAirport,
    sourceLinkedData,
    destLinkedData,
    srcDistanceData,
    destDistanceData,
    srcLinkedRailsData,
    destLinkedRailsData,
    aerial_distance,
    road_distance
  } = seoState;

  const isHindi = language === 'hindi' ? true : false;
  const srcName = src ? (isHindi && src.hindi_name ? src.hindi_name : src.name) : source.city;
  const destName = dest
    ? isHindi && dest.hindi_name
      ? dest.hindi_name
      : dest.name
    : destination.city;
  const { airline_contact_info_html: airlineContact } = airlineInfo;
  const isFlightSchedule = queryType && queryType.includes('flight-schedule') ? true : false;

  return (
    <>
      {airlineContact ? <AirlineContactInfo longDesc={airlineContact} isDweb={true} /> : null}
      {offersFromDb && offersFromDb.length > 0 ? (
        <Offer isDweb={true} offers={offersFromDb} />
      ) : null}

      {aerial_distance && road_distance ? (
        <SrcDestDistance
          title={`${srcName} to ${destName}`}
          aerial_distance={aerial_distance}
          road_distance={road_distance}
          isDweb={true}
        />
      ) : null}

      {srcDistanceData && srcDistanceData.length > 0 ? (
        <ListForLinks
          title={`Further Distance from ${srcName} (${source.iata})`}
          links={getListWithNewTitle(srcDistanceData, `${srcName} ${TO[language]} %s Distance`)}
          isDweb={true}
        />
      ) : null}

      {destDistanceData && destDistanceData.length > 0 ? (
        <ListForLinks
          title={`Further Distance from ${destName} (${destination.iata})`}
          links={getListWithNewTitle(destDistanceData, `${destName} ${TO[language]} %s Distance`)}
          isDweb={true}
        />
      ) : null}

      {sourceLinkedData && sourceLinkedData.length > 0 ? (
        <ListForLinks
          title={`Further Flights from ${srcName} (${source.iata})`}
          links={getListWithNewTitle(
            sourceLinkedData,
            `${srcName} ${TO[language]} %s ${
              isFlightSchedule ? FLIGHT_SCHEDULE_TEXT[language] : FLIGHTS_TEXT[language]
            }`
          )}
          isDweb={true}
        />
      ) : null}

      {destLinkedData && destLinkedData.length > 0 ? (
        <ListForLinks
          title={`Further Flights from ${destName} (${destination.iata})`}
          links={getListWithNewTitle(
            destLinkedData,
            `${destName} ${TO[language]} %s ${
              isFlightSchedule ? FLIGHT_SCHEDULE_TEXT[language] : FLIGHTS_TEXT[language]
            }`
          )}
          isDweb={true}
        />
      ) : null}

      <SeoSrpCarousel offers={offers} />
      {popularSectors ? (
        <ListForLinks
          title="Popular Sectors"
          html={popularSectors.api_url}
          links={[]}
          isDweb={true}
        />
      ) : null}

      {topSectors ? (
        <ListForLinks title="Top Sectors" html={topSectors.api_url} links={[]} isDweb={true} />
      ) : null}

      {popularLongHaulFlights ? (
        <ListForLinks
          title="Popular Long Haul Flights"
          html={popularLongHaulFlights.api_url}
          links={[]}
          isDweb={true}
        />
      ) : null}

      {topSectorsFromSource && topSectorsFromSource.length > 0 ? (
        <ListForLinks
          title={`Top Sectors From ${srcName}`}
          links={getListWithNewTitle(
            topSectorsFromSource,
            `${srcName} ${TO[language]} %s ${FLIGHTS_TEXT[language]}`
          )}
          isDweb={true}
        />
      ) : null}

      {topSectorsToDestination && topSectorsToDestination.length > 0 ? (
        <ListForLinks
          title={`Top Sectors To ${destName}`}
          links={getListWithNewTitle(
            topSectorsToDestination,
            `%s ${TO[language]} ${destName} ${FLIGHTS_TEXT[language]}`
          )}
          isDweb={true}
        />
      ) : null}

      {intlFlightsFromSource ? (
        <ListForLinks title="" html={intlFlightsFromSource.api_url} links={[]} isDweb={true} />
      ) : null}
      {intlFlightsToDestination ? (
        <ListForLinks title="" html={intlFlightsToDestination.api_url} links={[]} isDweb={true} />
      ) : null}
      {domAirlines ? (
        <ListForLinks title="Top Airlines" html={domAirlines.api_url} links={[]} isDweb={true} />
      ) : null}
      {topAirlines ? (
        <ListForLinks title="Top Sectors" html={topAirlines.api_url} links={[]} isDweb={true} />
      ) : null}

      {udaanSectors ? (
        <ListForLinks
          title="Udaan Sectors"
          html={udaanSectors.api_url}
          links={udaanSectors}
          isDweb={true}
        />
      ) : null}

      {newSectors ? (
        <ListForLinks
          title="New Sectors"
          html={newSectors.api_url}
          links={newSectors}
          isDweb={true}
        />
      ) : null}

      {topIntlRouteAirlines ? (
        <ListForLinks
          title="Top International Routes"
          html={topIntlRouteAirlines.api_url}
          links={[]}
          isDweb={true}
        />
      ) : null}

      {topIntlRoutes ? (
        <ListForLinks
          title="Top International Routes"
          html={topIntlRoutes.api_url}
          links={[]}
          isDweb={true}
        />
      ) : null}

      {topIntlCities ? (
        <ListForLinks
          title="Top International Cities"
          html={topIntlCities.api_url}
          links={[]}
          isDweb={true}
        />
      ) : null}

      {intlAirlines ? (
        <ListForLinks
          title="Top International Airlines"
          html={intlAirlines.api_url}
          links={[]}
          isDweb={true}
        />
      ) : null}

      {sourceAirport ? (
        <AirportContact
          contactDetailsHTML={sourceAirport.contact_details || ''}
          locName={srcName}
          isDweb={true}
        />
      ) : null}

      {destinationAirport ? (
        <AirportContact
          contactDetailsHTML={destinationAirport.contact_details || ''}
          locName={destName}
          isDweb={true}
        />
      ) : null}

      {hotels && hotels.length > 0 ? (
        <HotelsAttractionsInformation
          hotelsAttractions={hotels}
          hotelsAttractionsType="hotels"
          headerTitle={`Hotels near ${destination.airport}, ${destName}`}
          footerTitle={`view all hotels in ${destName}`}
          destUrl={destination.destination_city_hotels_link}
          isDweb={true}
        />
      ) : null}

      {attractions && attractions.length > 0 ? (
        <HotelsAttractionsInformation
          hotelsAttractions={attractions}
          hotelsAttractionsType="attractions"
          headerTitle={`Popular attractions in ${destName}`}
          footerTitle={`view ${destName} travel guide`}
          destUrl={destination.tguide_link || `/destinations/${dest.flights_url_phrase}/`}
          isDweb={true}
        />
      ) : null}

      {htl_city_links && htl_city_links.length ? (
        <ListForLinks title={`Hotels in ${destName}`} links={htl_city_links} isDweb={true} />
      ) : null}

      {popular_hotels && popular_hotels.length ? (
        <ListForLinks
          title={`Popular Hotels in ${destName}`}
          links={popular_hotels}
          isDweb={true}
        />
      ) : null}

      {srcLinkedRailsData && srcLinkedRailsData.links?.length ? (
        <ListForLinks
          title={srcLinkedRailsData.title}
          links={srcLinkedRailsData.links}
          isDweb={true}
        />
      ) : null}

      {destLinkedRailsData && destLinkedRailsData.links?.length ? (
        <ListForLinks
          title={destLinkedRailsData.title}
          links={destLinkedRailsData.links}
          isDweb={true}
        />
      ) : null}
    </>
  );
};

export default SrpSeoLeft;
